import emitter from "@webcore/core/events/eventemitter.ts";
import * as Sentry from "@sentry/react";


if (import.meta.env.DEV ) {
  // import("./utils/stats").then(({ initStats }) => initStats()).catch(() => {});
  import("./utils/eruda").then(({ initEruda }) => initEruda()).catch(() => {});
}
import("./main.app.ui").then(({ initUI }) => {
  initUI();
});

emitter.on("ui-ready", () => {
  import("./main.app").then(({ initApp }) => {
    initApp();
  });
});

//----------------------------------------------------------------

emitter.on("initialized", () => {
  emitter.emit("load");
});

if (!import.meta.env.DEV) {
  Sentry.init({
    dsn: "https://672aca45de6f0c6b2bd418cbae72c57e@o1388406.ingest.us.sentry.io/4510694810517504",
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 1.0,
  });
}